export default "__VITE_ASSET__oa7ajGkT__"